import gql from 'graphql-tag'

const OWNER_BUSINESS_QUERY = gql`query($ownerId: Int!){
    business(where:{owner_id: {_eq: $ownerId}}, order_by:{id: desc}) {
        id
        phone
        name
        address
        location_id
        owner_id
        logo
        license
        is_private
        sub_merchant_id
        user{
            id
            email
        }
        brand{
            id
            name
            is_instructor
        }
        location{
            id
            name
            latitude
            longitude
            url
            address
            business_id
            location_city{
                id
                name
                county_id
            }
        }
        classes{
            id
            name
            points_cost
            instructor_name
            instructor_id
            categories{
                id
                category{
                    id
                }
            }
            instructor{
                id
                name
            }
        }
        user_business_points{
            
            points
        }
    }
}`;

const GYMS_MEMBERSHIPS_QUERY = gql` query($userId: Int!){

    three_gym_membership(where:{business:{user: {id: {_eq: $userId}}}} ,order_by:{updated_at: desc}){

        id
        name
        in_years
        in_months
        in_days
        price
        cash_price
        pay_cash
        pay_points
        capacity
        business_id
        free_years
        free_months
        free_days
        males
        females
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        my_time_stamp
        business{
            id
            user{
                id
                email
            }
        }
        three_gym_membership_to_schedules{

            id
            three_gym_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_gym_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_gym_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }

}`

const MA_MEMBERSHIPS_QUERY= gql` query($userId: Int!){

    three_ma_membership(where:{business:{user: {id: {_eq: $userId}}}}, order_by:{updated_at: desc}){

        id
        name
        in_years
        in_months
        in_days
        males
        females
        price
        cash_price
        pay_cash
        pay_points
        capacity
        business_id
        free_years
        free_months
        free_days
        classes_number
        business{
            id
        }
        class{
            
            id
            name
            points_cost
            instructor_name
            instructor_id
            instructor{
                id
                name
            }
        }
        three_ma_membership_to_schedules{

            id
            three_ma_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_ma_membership_categories{

            id
            category{

                id
                name
            }
        }
        three_ma_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_ma_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }
}`


const CLASSES_MEMBERSHIPS_QUERY = gql` query($userId: Int!){

    three_class_membership(where:{business:{user: {id: {_eq: $userId}}}}, order_by:{updated_at: desc}){

        id
        name
        in_years
        in_months
        in_days
        males
        females
        price
        cash_price
        pay_cash
        pay_points
        capacity
        business_id
        free_years
        free_months
        free_days
        classes_number
        business{
            id
        }
        class{
            
            id
            name
            points_cost
            instructor_name
            instructor_id
            instructor{
                id
                name
            }
        }
        three_class_membership_to_schedules{

            id
            three_class_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_class_membership_categories{

            id
            category{

                id
                name
            }
        }
        three_class_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_class_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }
}`;

const STUDIOS_MEMBERSHIPS_QUERY = gql` query($userId: Int!){

    three_studio_membership(where:{business:{user: {id: {_eq: $userId}}}}, order_by:{updated_at: desc}){

        id
        name
        in_years
        in_months
        in_days
        males
        females
        price
        cash_price
        pay_cash
        pay_points
        capacity
        business_id
        free_years
        free_months
        free_days
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        my_time_stamp
        classes_number
        business{
            id
        }
        three_studio_membership_to_schedules{

            id
            three_studio_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_studio_membership_categories{

            id
            category{

                id
                name
            }
        }
        three_studio_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_studio_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }
}`

const FACILITY_QUERY = gql`query{
    facility(order_by:{name: asc}) {
        id
        name
    }
}`;

const GYMS_BUSINESS_SCHEDULES_QUERY = gql`query($ownerId: Int!){
    three_gym_schedule(where:{business:{owner_id: {_eq: $ownerId}}}, order_by:{updated_at: desc}) {
        id
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        start_time
        end_time
        business{
            id
        }
    }
}`;

const MA_BUSINESS_SCHEDULES_QUERY = gql`query($ownerId: Int!){
    three_ma_schedule(where:{business:{owner_id: {_eq: $ownerId}}}, order_by:{updated_at: desc}) {
        id
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        start_time
        end_time
        business{
            id
        }
    }
}`;

const CLASSES_BUSINESS_SCHEDULES_QUERY = gql`query($ownerId: Int!){
    three_class_schedule(where:{business:{owner_id: {_eq: $ownerId}}}, order_by:{updated_at: desc}) {
        id
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        start_time
        end_time
        business{
            id
        }
    }
}`;

const STUDIOS_BUSINESS_SCHEDULES_QUERY = gql`query($ownerId: Int!){
    three_studio_schedule(where:{business:{owner_id: {_eq: $ownerId}}}, order_by:{updated_at: desc}) {
        id
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        start_time
        end_time
        business{
            id
        }
    }
}`;

const CLIENT_GYMS_MEMBERSHIPS_QUERY = gql` query{

    three_gym_membership(order_by:{updated_at: desc}){

        id
        name
        in_years
        in_months
        in_days
        price
        cash_price
        pay_cash
        pay_points        
        capacity
        business_id
        free_years
        free_months
        free_days
        males
        females
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        my_time_stamp
        business{
            id
            user{
                id
                email
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                location_city{
                    id
                    name
                    county_id
                }
            }
        }
        three_gym_membership_to_schedules{

            id
            three_gym_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_gym_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_gym_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }
}`

const CLIENT_MA_MEMBERSHIPS_QUERY= gql` query{

    three_ma_membership(order_by:{updated_at: desc}){

        id
        name
        in_years
        in_months
        in_days
        price
        cash_price
        pay_cash
        pay_points        
        males
        females
        capacity
        business_id
        free_years
        free_months
        free_days
        classes_number
        business{
            id
            location{
                id
                name
                address
                latitude
                longitude
                url
                location_city{
                    id
                    name
                    county_id
                }
            }
        }
        class{
            
            id
            name
            points_cost
            instructor_name
            instructor_id
            instructor{
                id
                name
            }
        }
        three_ma_membership_to_schedules{

            id
            three_ma_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_ma_membership_categories{

            id
            category{

                id
                name
            }
        }
        three_ma_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_ma_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }
}`


const CLIENT_CLASSES_MEMBERSHIPS_QUERY = gql` query{

    three_class_membership(order_by:{updated_at: desc}){

        id
        name
        in_years
        in_months
        in_days
        males
        females
        price
        cash_price
        pay_cash
        pay_points        
        capacity
        business_id
        free_years
        free_months
        free_days
        classes_number
        business{
            id
            location{
                id
                name
                address
                latitude
                longitude
                url
                location_city{
                    id
                    name
                    county_id
                }
            }
        }
        class{
            
            id
            name
            points_cost
            instructor_name
            instructor_id
            instructor{
                id
                name
            }
        }
        three_class_membership_to_schedules{

            id
            three_class_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_class_membership_categories{

            id
            category{

                id
                name
            }
        }
        three_class_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_class_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }
}`;

const USER_GYMS_MEMBERSHIP_QUERY = gql` query($userId: Int!){

    three_user_gym_membership(where:{user:{id: {_eq: $userId}}}, order_by:{updated_at: desc}){

        id
        uuid
        start_date
        end_date
        three_gym_membership{

            id
            name
            in_years
            in_months
            in_days
            price
            cash_price
            pay_cash
            pay_points
            capacity
            business_id
            free_years
            free_months
            free_days
            males
            females
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            my_time_stamp
            business{
                id
                name
                logo
                user{
                    id
                    email
                }
                location{
                    id
                    name
                    address
                    latitude
                    longitude
                    url
                    location_city{
                        id
                        name
                        county_id
                    }
                }
            }
            three_gym_membership_to_schedules{
    
                id
                three_gym_schedule{
    
                    id
                    monday
                    tuesday
                    wednesday
                    thursday
                    friday
                    saturday
                    sunday
                    start_time
                    end_time
                    business{
                        id
                    }
                }
            }
            three_gym_membership_facilities{
    
                id
                facility{
    
                    id
                    name
                }
            }
            three_user_gym_memberships{
    
                id
                start_date
                end_date
                user{
                    id
                    name
                }
            }
        }
    }
}`;

const USER_MA_MEMBERSHIP_QUERY = gql` query($userId: Int!){

    three_user_ma_membership(where:{user:{id: {_eq: $userId}}}, order_by:{updated_at: desc}){

        id
        uuid
        start_date
        end_date
        attended
        three_user_ma_membership_attendances{

            id 
            user_membership_id
            attendance_date
            week_day
        }
        three_ma_membership{

            id
            name
            in_years
            in_months
            in_days
            price
            cash_price
            pay_cash
            pay_points            
            capacity
            business_id
            free_years
            free_months
            free_days
            males
            females    
            classes_number
            business{
                id
                location{
                    id
                    name
                    address
                    latitude
                    longitude
                    url
                    location_city{
                        id
                        name
                        county_id
                    }
                }
            }
            class{
                id
                name
                instructor_name
                level
                business_id
                image_1
                image_2
                image_3
                image_4
                image_5
                image_6
                image_7
                image_8
                is_online
                description
                location{
                    id
                    name
                    address
                    latitude
                    longitude
                    url
                    location_city{
                        id
                        name
                        county_id
                    }
                }
                business{
                    id
                    name
                    logo
                    is_private
                }
                categories{
                    category{
                        id
                        name
                    }
                }
                instructor{
                    id
                    name
                    logo
                }
            }
            three_ma_membership_to_schedules{
    
                id
                three_ma_schedule{
    
                    id
                    monday
                    tuesday
                    wednesday
                    thursday
                    friday
                    saturday
                    sunday
                    start_time
                    end_time
                    business{
                        id
                    }
                }
            }
            three_ma_membership_categories{
    
                id
                category{
    
                    id
                    name
                }
            }
            three_ma_membership_facilities{
    
                id
                facility{
    
                    id
                    name
                }
            }
            three_user_ma_memberships{

                id
                start_date
                end_date
                user{
                    id
                    name
                }
            }
        }
    }
}`;

const USER_CLASSES_MEMBERSHIP_QUERY = gql` query($userId: Int!){

    three_user_class_membership(where:{user:{id: {_eq: $userId}}}, order_by:{updated_at: desc}){

        id
        uuid
        start_date
        end_date
        attended
        three_user_class_membership_attendances{

            id 
            user_membership_id
            attendance_date
            week_day
        }
        three_class_membership{

            id
            name
            in_years
            in_months
            in_days
            price
            cash_price
            pay_cash
            pay_points            
            capacity
            business_id
            free_years
            free_months
            free_days
            males
            females    
            classes_number
            business{
                id
                location{
                    id
                    name
                    address
                    latitude
                    longitude
                    url
                    location_city{
                        id
                        name
                        county_id
                    }
                }
            }
            class{
                id
                name
                instructor_name
                level
                business_id
                image_1
                image_2
                image_3
                image_4
                image_5
                image_6
                image_7
                image_8
                is_online
                description
                location{
                    id
                    name
                    address
                    latitude
                    longitude
                    url
                    location_city{
                        id
                        name
                        county_id
                    }
                }
                business{
                    id
                    name
                    logo
                    is_private
                }
                categories{
                    category{
                        id
                        name
                    }
                }
                instructor{
                    id
                    name
                    logo
                }
            }
            three_class_membership_to_schedules{
    
                id
                three_class_schedule{
    
                    id
                    monday
                    tuesday
                    wednesday
                    thursday
                    friday
                    saturday
                    sunday
                    start_time
                    end_time
                    business{
                        id
                    }
                }
            }
            three_class_membership_categories{
    
                id
                category{
    
                    id
                    name
                }
            }
            three_class_membership_facilities{
    
                id
                facility{
    
                    id
                    name
                }
            }
            three_user_class_memberships{

                id
                start_date
                end_date
                user{
                    id
                    name
                }
            }
        }
    }
}`;

const USER_STUDIOS_MEMBERSHIP_QUERY = gql` query($userId: Int!){

    three_user_studio_membership(where:{user:{id: {_eq: $userId}}}, order_by:{updated_at: desc}){

        id
        uuid
        start_date
        end_date
        three_studio_membership{

            id
            name
            in_years
            in_months
            in_days
            price
            cash_price
            pay_cash
            pay_points            
            capacity
            business_id
            free_years
            free_months
            free_days
            classes_number
            males
            females
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            my_time_stamp
            business{
                id
                name
                logo
                user{
                    id
                    email
                }
                location{
                    id
                    name
                    address
                    latitude
                    longitude
                    url
                    location_city{
                        id
                        name
                        county_id
                    }
                }
            }
            three_studio_membership_to_schedules{
    
                id
                three_studio_schedule{
    
                    id
                    monday
                    tuesday
                    wednesday
                    thursday
                    friday
                    saturday
                    sunday
                    start_time
                    end_time
                    business{
                        id
                    }
                }
            }
            three_studio_membership_categories{

                id
                category{
    
                    id
                    name
                }
            }
            three_studio_membership_facilities{
    
                id
                facility{
    
                    id
                    name
                }
            }
            three_user_studio_memberships{
    
                id
                start_date
                end_date
                user{
                    id
                    name
                }
            }
        }
    }
}`;


const PAGE_GYMS_MEMBERSHIPS_QUERY = gql`query($businessId: Int!){

    three_gym_membership(where:{business: {id: {_eq: $businessId}}}){

        id
        name
        in_years
        in_months
        in_days
        price
        cash_price
        pay_cash
        pay_points        
        capacity
        business_id
        free_years
        free_months
        free_days
        males
        females
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        my_time_stamp
        business{
            id
            user{
                id
                email
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                location_city{
                    id
                    name
                    county_id
                }
            }
        }
        three_gym_membership_to_schedules{

            id
            three_gym_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_gym_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_gym_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }
}`;


const PAGE_MA_MEMBERSHIPS_QUERY= gql` query($businessId: Int!){

    three_ma_membership(where:{business: {id: {_eq: $businessId}}}){

        id
        name
        in_years
        in_months
        in_days
        price
        cash_price
        pay_cash
        pay_points        
        capacity
        business_id
        free_years
        free_months
        free_days
        males
        females
        classes_number
        business{
            id
            location{
                id
                name
                address
                latitude
                longitude
                url
                location_city{
                    id
                    name
                    county_id
                }
            }
        }
        class{
            id
            name
            instructor_name
            level
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            is_online
            description
            location{
                id
                name
                address
                latitude
                longitude
                url
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
            }
            categories{
                category{
                    id
                    name
                }
            }
            instructor{
                id
                name
                logo
            }
        }
        three_ma_membership_to_schedules{

            id
            three_ma_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_ma_membership_categories{

            id
            category{

                id
                name
            }
        }
        three_ma_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_ma_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }
}`;


const PAGE_CLASSES_MEMBERSHIPS_QUERY= gql` query($businessId: Int!){

    three_ma_membership(where:{business: {id: {_eq: $businessId}}}){

        id
        name
        in_years
        in_months
        in_days
        price
        cash_price
        pay_cash
        pay_points        
        capacity
        business_id
        free_years
        free_months
        free_days
        classes_number
        business{
            id
            location{
                id
                name
                address
                latitude
                longitude
                url
                location_city{
                    id
                    name
                    county_id
                }
            }
        }
        class{
            id
            name
            instructor_name
            level
            business_id
            image_1
            image_2
            image_3
            image_4
            image_5
            image_6
            image_7
            image_8
            is_online
            description
            location{
                id
                name
                address
                latitude
                longitude
                url
                location_city{
                    id
                    name
                    county_id
                }
            }
            business{
                id
                name
                logo
                is_private
            }
            categories{
                category{
                    id
                    name
                }
            }
            instructor{
                id
                name
                logo
            }
        }
        three_class_membership_to_schedules{

            id
            three_class_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_class_membership_categories{

            id
            category{

                id
                name
            }
        }
        three_class_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_class_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }
}`;

const PAGE_STUDIOS_MEMBERSHIPS_QUERY = gql`query($businessId: Int!){

    three_studio_membership(where:{business: {id: {_eq: $businessId}}}){

        id
        name
        in_years
        in_months
        in_days
        price
        cash_price
        pay_cash
        pay_points        
        capacity
        business_id
        free_years
        free_months
        free_days
        males
        females
        image_1
        image_2
        image_3
        image_4
        image_5
        image_6
        image_7
        image_8
        my_time_stamp
        business{
            id
            user{
                id
                email
            }
            location{
                id
                name
                address
                latitude
                longitude
                url
                location_city{
                    id
                    name
                    county_id
                }
            }
        }
        three_studio_membership_to_schedules{

            id
            three_studio_schedule{

                id
                monday
                tuesday
                wednesday
                thursday
                friday
                saturday
                sunday
                start_time
                end_time
                business{
                    id
                }
            }
        }
        three_studio_membership_categories{

            id
            category{

                id
                name
            }
        }
        three_studio_membership_facilities{

            id
            facility{

                id
                name
            }
        }
        three_user_studio_memberships{

            id
            start_date
            end_date
            user{
                id
                name
            }
        }
    }
}`

const USER_PUSH_QUERY = gql`query{
    
    user_push_subscription(order_by:{updated_at: desc}){
       
        id
        end_point
        auth
        p256dh
    }
}`;


const MEMBERSHIP_USER_BOOKINGS_QUERY = gql`query($membershipUserId: Int!, $membershipStartDate: date!){
    
    bookings(where: {_and:[
        
        {studio_membership_user_id: {_eq: $membershipUserId}},
        {day_date: {_gte: $membershipStartDate}}
    ]},
        order_by: {day_date: desc, slot: {start_time: asc}})
    {
        id
        user_id
        slot_id
        points_cost
        day_date
        uuid
        attended
        slot{
            id
            start_time
            end_time
            class{
            id
            name
                business{
                    id
                    name
                }           
            }
        }
    }
}`;

const USER_LEVELS_QUERY = gql`query($userId: Int!){
        
    three_user_ma_level(where: 
        {_and:[
        
            {user_id: {_eq: $userId}},
         ]}
        ){
        
        id
        
        category{

            id
            name
        }

        user{
            id
            name
        }
        
        three_ma_level{
            id
            name
        }
    }
}`;

const MA_LEVELS_QUERY = gql`query{
    
    three_ma_level{

        id
        name
    }
}`;

const MA_CLASS_CATEGORY_QUERY = gql`query($categoryId: Int!){
    
    category(where: {id: {_eq: $categoryId}}){

        id
        name
    }
}`


export default {
    
    owner_business_query: OWNER_BUSINESS_QUERY,

    gyms_membership_query: GYMS_MEMBERSHIPS_QUERY,

    ma_membership_query: MA_MEMBERSHIPS_QUERY,

    classes_membership_query: CLASSES_MEMBERSHIPS_QUERY,

    studios_membership_query: STUDIOS_MEMBERSHIPS_QUERY,

    facility_query: FACILITY_QUERY,

    gyms_business_schedules_query: GYMS_BUSINESS_SCHEDULES_QUERY,

    ma_business_schedules_query: MA_BUSINESS_SCHEDULES_QUERY,

    classes_business_schedules_query: CLASSES_BUSINESS_SCHEDULES_QUERY,

    studios_business_schedules_query: STUDIOS_BUSINESS_SCHEDULES_QUERY,

    client_gyms_membership_query: CLIENT_GYMS_MEMBERSHIPS_QUERY,

    client_ma_membership_query: CLIENT_MA_MEMBERSHIPS_QUERY,

    client_classes_membership_query: CLIENT_CLASSES_MEMBERSHIPS_QUERY,

    user_gyms_membership_query: USER_GYMS_MEMBERSHIP_QUERY,

    user_ma_membership_query: USER_MA_MEMBERSHIP_QUERY,

    user_classes_membership_query: USER_CLASSES_MEMBERSHIP_QUERY,

    user_studios_membership_query: USER_STUDIOS_MEMBERSHIP_QUERY,

    page_gyms_memberships_query: PAGE_GYMS_MEMBERSHIPS_QUERY,

    page_ma_memberships_query: PAGE_MA_MEMBERSHIPS_QUERY,

    page_classes_memberships_query : PAGE_CLASSES_MEMBERSHIPS_QUERY,

    page_studios_memberships_query : PAGE_STUDIOS_MEMBERSHIPS_QUERY,

    user_push_query : USER_PUSH_QUERY,

    membership_user_bookings_query: MEMBERSHIP_USER_BOOKINGS_QUERY,
    
    user_levels_query: USER_LEVELS_QUERY,

    ma_levels_query: MA_LEVELS_QUERY,

    //not needed
    ma_class_category_query: MA_CLASS_CATEGORY_QUERY,


}
